/**
 * Groups field wrappers by their section key.
 *
 * @param {import('../../contracts/forms.js').FieldDef[]} fields
 * @param {{ getWrapper: () => HTMLElement }[]} fieldInstances
 * @param {import('../../contracts/field-sections.js').FieldSectionDef[]} sections
 * @returns {{ sectionFields: Map<string, HTMLElement[]>, unsectionedFields: HTMLElement[] }}
 */
export function groupFieldsBySection(fields, fieldInstances, sections) {
  const sectionKeys = new Set(sections.map(s => s.key));

  /** @type {Map<string, HTMLElement[]>} */
  const sectionFields = new Map(sections.map(s => [s.key, []]));

  /** @type {HTMLElement[]} */
  const unsectionedFields = [];

  for (let i = 0; i < fields.length; i++) {
    const def = fields[i];
    const wrapper = fieldInstances[i].getWrapper();

    if (def.section && sectionKeys.has(def.section)) {
      /** @type {HTMLElement[]} */ (sectionFields.get(def.section)).push(wrapper);
    } else {
      unsectionedFields.push(wrapper);
    }
  }

  return { sectionFields, unsectionedFields };
}
